"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_slick_1 = __importDefault(require("react-slick"));
var AcInfoCardCarousel_module_scss_1 = __importDefault(require("./AcInfoCardCarousel.module.scss"));
var PrevArrow = function () {
    return (react_1.default.createElement("span", { className: "rounded-lg shadow-lg" },
        react_1.default.createElement("i", { className: "fas fa-chevron-left fa-fw text-primary" })));
};
exports.AcInfoCardCarousel = function (_a) {
    var cards = _a.cards;
    var settings = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 8,
        slidesToScroll: 1,
        prevArrow: react_1.default.createElement(PrevArrow, null),
        responsive: [
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 7,
                },
            },
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 1150,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 840,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };
    var renderCards = function () {
        if (cards && cards.length > 0) {
            return cards.map(function (card, index) {
                return react_1.default.createElement("div", { key: "SliderCard:" + index }, card);
            });
        }
        return undefined;
    };
    return (react_1.default.createElement("div", { className: clsx_1.default(AcInfoCardCarousel_module_scss_1.default.sliderWrapper, 'ac-info-card-carousel') },
        react_1.default.createElement(react_slick_1.default, __assign({}, settings), renderCards())));
};
exports.AcInfoCardCarousel.displayName = 'AcInfoCardCarousel';
//# sourceMappingURL=AcInfoCardCarousel.js.map